import { AnalysisState } from '../hooks/rules-state';
export function resolveGroupAnalysisState(state) {
  const isAnalyzing = state === AnalysisState.Analyzing;
  const isFirstAnalysis = state === AnalysisState.FirstAnalyzing;
  const isAnalyzeFailed = state === AnalysisState.AnalyzeFailed;
  const isPendingResults = state === AnalysisState.AnalyzeDonePendingResults;
  const isFetchResultsFailed = state === AnalysisState.AnalyzeDoneFailedToFetchResults;
  const isFetchResultSucceeded = state === AnalysisState.AnalyzeDoneResultsReady;
  const isPerformingAnalysis = isAnalyzing || isFirstAnalysis;
  return {
    isAnalyzeFailed,
    isAnalyzing,
    isFetchResultSucceeded,
    isFetchResultsFailed,
    isFirstAnalysis,
    isPendingResults,
    isPerformingAnalysis
  };
}
//# sourceMappingURL=resolve-group-analysis-state.js.map